const translations = {
    connecting: 'Connecting to John Deere...',
    error: 'Failed to connect to John Deere',
    tryAgain: 'Try Again'
};

export default translations;
